import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-funnel-series-options',
	templateUrl:'./AgFunnelSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgFunnelSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgFunnelSeriesPluginCompPage
{
	mdContent_708 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgFunnelSeriesOptions;
\`\`\``;
}
